import { Role } from 'enums';
import { UserViewModel } from 'models/User';

/**
 * Determines if the user has the appropriate role.  Used for Role Base Access Control
 * @param allowedRoles
 * @param user
 * @returns Boolean indicating if the user does or does not have one of the specified roles
 */
export const hasAnyRole = (
  allowedRoles: Role[],
  user: UserViewModel,
): boolean => {
  return (
    user &&
    allowedRoles &&
    !allowedRoles.some((role) => user.roles.includes(role))
  );
};

/**
 * Determines if the user has the appropriate role.  Used for Role Base Access Control
 * @param allowedRole
 * @param user
 * @returns Boolean indicating if the user does or does not have the specified roles
 */
export const hasRole = (role: Role, user: UserViewModel): boolean => {
  return user && user.roles.includes(role);
};
